import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const STOCK_TRANSFER_URL = `${backendUrl}/stockTransfer`;

const initialState = {
  isLoading: false,
  error: null,
  transfers: [],
  transfer: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "stockTransfer",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getTransfersSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.transfers = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getTransferSuccess(state, action) {
      state.isLoading = false;
      state.transfer = action.payload;
    },
    clearTransfer(state) {
      state.transfer = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getStockTransfers({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(STOCK_TRANSFER_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getTransfersSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getStockTransfer(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${STOCK_TRANSFER_URL}/${id}`);
      dispatch(slice.actions.getTransferSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function createStockTransfer(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(STOCK_TRANSFER_URL, data);
      dispatch(slice.actions.getTransferSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function assignWarehouseStoreToTransferLine(stockTransferId, lineId, warehouseStoreId) {
  return async () => {
    const response = await axios.patch(
      `${STOCK_TRANSFER_URL}/${stockTransferId}/lines/${lineId}/warehouse-inventory-store`,
      { warehouseStoreId }
    );
    return response.data;
  };
}

export const { clearTransfer } = slice.actions;
